import { render, staticRenderFns } from "./TinyMceStyles.vue?vue&type=template&id=673e41be&"
import script from "./TinyMceStyles.vue?vue&type=script&lang=js&"
export * from "./TinyMceStyles.vue?vue&type=script&lang=js&"
import style0 from "./TinyMceStyles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports